<template>
  <v-container
      class="fill-height"
      :fluid="true"
  >
    <v-row justify="center">
      <v-col align-self="center">
        <v-card
            class="mx-auto px-6 py-8"
            max-width="400"
        >
          <p class="text-h5 mb-6">Sign In</p>
          <v-form
              v-model="valid"
              ref="signIn"
              @submit="login(email, password, redirectTo)"
          >
            <v-text-field
                v-model="email"
                :readonly="loading"
                :rules="emailRules"
                class="mb-2"
                label="Email"
                :clearable="true"
            />

            <v-text-field
                v-model="password"
                :readonly="loading"
                :type="showPass ? 'text' : 'password'"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="passwordRules"
                :clearable="true"
                label="Password"
                placeholder="Enter your password"
                @click:append="showPass = !showPass"
                @keydown.enter.prevent="login(email, password, redirectTo)"
            />

            <p v-show="errorMessage !== null" class="text-subtitle-2 text-red">{{ errorMessage }}</p>

            <br>

            <v-btn
                color="success"
                size="large"
                variant="elevated"
                :block="true"
                v-on:click="login(email, password, redirectTo)"
            >
              Sign In
            </v-btn>
          </v-form>
          <br>
          <v-btn
              color="green"
              size="large"
              variant="plain"
              :block="true"
              v-on:click="forgotPassword()"
          >
            Forgot password
          </v-btn>
          <v-overlay
              v-model="loading"
              :persistent="loading"
              :contained="true"
              class="align-center justify-center"
          >
            <v-progress-circular
                indeterminate
                size="64"
            />
          </v-overlay>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {auth} from "@/common/auth";
import {router} from "@/router";
import {readonly, inject} from "vue";
import {messages} from "@/common/enum/messages";

export default {
  name: 'SignView',
  emits: ['refresh-chat-state'],
  props: {
    redirectTo: {
      default: 'home',
      type: String
    }
  },
  data() {
    return {
      forgotRedirectionLink: readonly({
        name: 'forgot-password'
      }),
      email: '',
      password: '',
      showPass: false,
      valid: null,
      loading: false,
      errorMessage: null,

      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
      ],
    }
  },
  watch: {
    email()  {
      if (this.errorMessage !== null) {
        this.resetErrorMessage()
      }
    },
    password() {
      if (this.errorMessage !== null) {
      this.resetErrorMessage()
      }
    }
  },
  setup() {
    return {
      isAuthorized: inject('authorization').isAuthorized,
      switchAuthorizationState: inject('authorization').switchState,
    }
  },
  mounted() {
    if (this.isAuthorized) {
      router.push({name: this.redirectionLink})
    }
  },
  methods: {
    login(username, password, redirectionLink) {
      this.$refs.signIn.validate()
      if (this.valid !== true) {
        return
      }

      this.resetErrorMessage()
      this.loading = true
      auth.issueToken(username, password, (success) => {
        this.loading = false
        if (success !== true) {
          this.errorMessage = messages.en.sign_view.unauthorized_error
          return
        }

        this.switchAuthorizationState()
        this.$emit('refresh-chat-state')
        router.push({name: redirectionLink})
      })
    },
    forgotPassword() {
      router.push(this.forgotRedirectionLink)
    },
    resetErrorMessage() {
      this.errorMessage = null
    }
  },
}
</script>

<style scoped>

</style>